import { combineReducers } from 'redux';

const orderDetailInitialState = {
  payStatus: 0,
};

const refundDetailInitialState = {
  payStatus: 0,
};

function orderDetailsReducer(state = {}, action) {
  switch (action.type) {
    case 'PAY_BY_WECHAT':
    case 'PAY_BY_WALLET': {
      const { payModule, id } = action;

      if (payModule !== 1) {
        return state;
      }
      const prevState = state[id] || orderDetailInitialState;
      return {
        ...state,
        [id]: {
          ...prevState,
          payStatus: 1,
        },
      };
    }
    case 'PAY_BY_WECHAT_COMPLETION':
    case 'PAY_BY_WALLET_COMPLETION': {
      const { payModule, id, error } = action;

      if (payModule !== 1) {
        return state;
      }

      const prevState = state[id] || orderDetailInitialState;
      return {
        ...state,
        [id]: {
          ...prevState,
          payStatus: error ? -1 : 2,
        },
      };
    }
    default:
      return state;
  }
}

function refundDetailsReducer(state = {}, action) {
  switch (action.type) {
    case 'PAY_BY_WECHAT': {
      const { payModule, id } = action;

      if (payModule !== 2) {
        return state;
      }

      const prevState = state[id] || refundDetailInitialState;
      return {
        ...state,
        [id]: {
          ...prevState,
          payStatus: 1,
        },
      };
    }
    case 'PAY_BY_WECHAT_COMPLETION': {
      const { payModule, id, error } = action;

      if (payModule !== 2) {
        return state;
      }

      const prevState = state[id] || refundDetailInitialState;
      return {
        ...state,
        [id]: {
          ...prevState,
          payStatus: error ? -1 : 2,
        },
      };
    }
    default:
      return state;
  }
}

export default combineReducers({
  orderDetails: orderDetailsReducer,
  refundDetails: refundDetailsReducer,
});
